// extracted by mini-css-extract-plugin
export default {"mCard":"xC-z","image":"yC-z","imageNoBackground":"zC-z","imageHasCategory":"AC-z","fullWidth":"BC-z"};